import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';
import { AscService } from '../../services/asc/asc.service';
import { AscCheque } from '../../interfaces/asc.interface';

export const chequeDetailResolver: ResolveFn<AscCheque> = (route: ActivatedRouteSnapshot) => {
  return inject(AscService).getChequeDetail(route.paramMap.get('numcheque')!);
};
